import { OptionType } from '@morph-mapper/types';
import { DerivationAccordion } from '../../molecules/derivation-accordion/derivation-accordion';
import { OptionViewModel } from '../../utils';

export type NodeDerivationsPanelProps = {
  models: OptionViewModel[];
  onOpenGraph: (key: string, graphId?: string) => void;
};

export const NodeDerivationsPanel = ({
  models,
  onOpenGraph,
}: NodeDerivationsPanelProps) => {
  const items = models
    .filter((m) => m.type === OptionType.Graph)
    .filter((m) => m.visible);

  return <DerivationAccordion items={items} onOpen={onOpenGraph} />;
};
